import React from 'react';

/**
 * BrowserChrome — wraps any image or video in a faux browser window.
 * Used on the marketing landing page and /features page to make
 * product screenshots and videos look more polished.
 *
 * @param {{ children: React.ReactNode, urlPath: string, className?: string }} props
 */
export default function BrowserChrome({ children, urlPath = '/dashboard', className = '' }) {
    return (
        <div className={`rounded-xl overflow-hidden shadow-2xl border border-gray-200 bg-white ${className}`}>
            {/* Top chrome bar */}
            <div className="bg-gray-100 border-b border-gray-200 px-4 py-2.5 flex items-center gap-3">
                {/* Traffic light dots */}
                <div className="flex items-center gap-1.5 flex-shrink-0">
                    <div className="w-3 h-3 rounded-full bg-red-400" aria-hidden="true" />
                    <div className="w-3 h-3 rounded-full bg-yellow-400" aria-hidden="true" />
                    <div className="w-3 h-3 rounded-full bg-green-400" aria-hidden="true" />
                </div>
                {/* Fake URL bar */}
                <div className="flex-1 bg-white border border-gray-200 rounded-md px-3 py-1 flex items-center gap-2 min-w-0">
                    <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <span className="text-xs text-gray-500 truncate font-mono">
                        time.hisland.com{urlPath}
                    </span>
                </div>
            </div>
            {/* Content */}
            <div className="relative overflow-hidden">
                {children}
            </div>
        </div>
    );
}
